import { create } from "zustand";

interface MenuState {
  isMenuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  toggleMenu: () => void;
}

export const useMenuStore = create<MenuState>(set => ({
  isMenuOpen: false,
  setMenuOpen: open => set({ isMenuOpen: open }),
  toggleMenu: () => set(state => ({ isMenuOpen: !state.isMenuOpen })),
}));
